import React from 'react'

const ThemeRoundedButtons = ({ setThemeRounded }) => {
    return (
        <div className='flex justify-center gap-3'>
            <ThemeCircle setThemeRounded={setThemeRounded} value="" rounded="rounded-[0px]" />
            <ThemeCircle setThemeRounded={setThemeRounded} value="sm" rounded="rounded-[5px]" />
            <ThemeCircle setThemeRounded={setThemeRounded} value="md" rounded="rounded-[10px]" />
            <ThemeCircle setThemeRounded={setThemeRounded} value="lg" rounded="rounded-[20px]" />
        </div>
    )
}

const ThemeCircle = (props) => {
    return (
        <button onClick={() => props.setThemeRounded(props.value)} className={'w-[30px] h-[30px] bg-slate-300 dark:bg-slate-800 border-4 border-white/50 ' + props.rounded}></button>
    )
}

const ThemeRoundedSwitcher = ({ setThemeRounded }) => {

    //console.log(setThemeRounded)

    return (
        <div >
            <ThemeRoundedButtons setThemeRounded={setThemeRounded} />
        </div>
    )
}

export default ThemeRoundedSwitcher